import { ParseQuery } from './parse-query';
import { UserQuery } from './user-query';
import { EmailVerification } from '@shared/data';

export class EmailVerificationQuery extends ParseQuery<EmailVerification> {
  constructor() {
    super(EmailVerification);
  }
}